import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
  Button,
  ButtonToolbar,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { countryList } from '../../../../../helpers/shipping/CountriesNew';

const URL = 'https://api.musicmarquee.co.uk';
const authHeaders = () => ({ Authorization: localStorage.getItem('mm_admin') });
const currencyFormatGbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const countries = countryList
  .slice()
  .sort((a, b) => a.label.localeCompare(b.label));

const formatCsvValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return `"${`${value}`.replace(/"/g, '""')}"`;
};

const editableFields = [
  { key: 'status', label: 'Status', type: 'text' },
  {
    key: 'total_value', label: 'Total Value', type: 'number', step: '0.01',
  },
  { key: 'shipping_service', label: 'Shipping Service', type: 'text' },
  { key: 'shipping_carrier', label: 'Shipping Carrier', type: 'text' },
  { key: 'tracking_number', label: 'Tracking Number', type: 'text' },
  { key: 'shipped_date', label: 'Shipped Date', type: 'datetime-local' },
  {
    key: 'order_fee', label: 'Order Fee', type: 'number', step: '0.01',
  },
  {
    key: 'packaging_fee', label: 'Packaging Fee', type: 'number', step: '0.01',
  },
  { key: 'package_size', label: 'Package Size', type: 'text' },
  { key: 'weight', label: 'Weight', type: 'number' },
  { key: 'mm_package_size', label: 'MM Package Size', type: 'text' },
  {
    key: 'client_shipping_price', label: 'Client Shipping Price', type: 'number', step: '0.01',
  },
  {
    key: 'mm_shipping_cost', label: 'MM Shipping Cost', type: 'number', step: '0.01',
  },
  {
    key: 'shipping_vat', label: 'Shipping VAT', type: 'number', step: '0.01',
  },
  {
    key: 'fee_vat', label: 'Fee VAT', type: 'number', step: '0.01',
  },
  { key: 'shipping_zone', label: 'Shipping Zone', type: 'text' },
  { key: 'client_id', label: 'Client ID', type: 'number' },
  {
    key: 'customs_tariff', label: 'Customs Tariff', type: 'number', step: '0.01',
  },
];

const formatDate = value => (value ? `${value}`.slice(0, 10) : '');

const formatDateTimeInput = (value) => {
  if (!value) {
    return '';
  }

  return `${value}`.slice(0, 16);
};

const getFieldValue = (fulfilment, field) => {
  if (!fulfilment || fulfilment[field.key] === null || fulfilment[field.key] === undefined) {
    return '';
  }

  if (field.type === 'datetime-local') {
    return formatDateTimeInput(fulfilment[field.key]);
  }

  return fulfilment[field.key];
};

class BandcampFulfilmentsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 0,
      count: 0,
      page: 0,
      pageSize: 50,
      loading: false,
      exporting: false,
      selected: null,
      selectedOriginal: null,
      isEditing: false,
      deleteEnabled: false,
      clients: [],
      clientId: '',
      shippedDateFrom: '',
      shippedDateTo: '',
      saveMessage: '',
      deleteMessage: '',
      tableState: null,
      tableFilters: [],
    };
  }

  componentDidMount() {
    this.getClients();
  }

  getClients = () => {
    axios.post(
      `${URL}/admin/bandcamp/filter-clients`,
      {},
      { headers: authHeaders() },
    )
      .then((response) => {
        this.setState({
          clients: response.data.clients || [],
        });
      })
      .catch(() => {
        this.setState({
          saveMessage: 'There was a problem loading clients.',
        });
      });
  };

  fetchData = (state) => {
    this.setState({
      loading: true,
      tableState: state,
      page: state.page,
      pageSize: state.pageSize,
    });

    axios.post(
      `${URL}/admin/bandcamp/fulfilments/list`,
      {
        page: state.page,
        pageSize: state.pageSize,
        sorted: state.sorted,
        filtered: state.filtered,
        clientId: this.state.clientId,
        shippedDateFrom: this.state.shippedDateFrom,
        shippedDateTo: this.state.shippedDateTo,
      },
      { headers: authHeaders() },
    )
      .then((response) => {
        this.setState({
          data: response.data.items || [],
          pages: response.data.pages || 0,
          count: response.data.count || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          saveMessage: 'There was a problem loading fulfilments.',
        });
      });
  };

  refreshTable = () => {
    if (this.state.tableState) {
      this.fetchData(Object.assign({}, this.state.tableState, {
        page: this.state.page,
        pageSize: this.state.pageSize,
        filtered: this.state.tableFilters,
      }));
    }
  };

  selectFulfilment = (fulfilment) => {
    this.setState({
      selected: Object.assign({}, fulfilment),
      selectedOriginal: Object.assign({}, fulfilment),
      isEditing: false,
      deleteEnabled: false,
      saveMessage: '',
      deleteMessage: '',
    });
  };

  updateFilter = (field, value) => {
    this.setState({ [field]: value, page: 0 }, () => {
      if (this.state.tableState) {
        this.fetchData(Object.assign({}, this.state.tableState, {
          page: 0,
          pageSize: this.state.pageSize,
          filtered: this.state.tableFilters,
        }));
      }
    });
  };

  updateTableFilters = (tableFilters) => {
    this.setState({ tableFilters, page: 0 });
  };

  resetFilters = () => {
    this.setState({
      clientId: '',
      shippedDateFrom: '',
      shippedDateTo: '',
      tableFilters: [],
      page: 0,
    }, () => {
      if (this.state.tableState) {
        this.fetchData(Object.assign({}, this.state.tableState, {
          page: 0,
          pageSize: this.state.pageSize,
          filtered: [],
        }));
      }
    });
  };

  updateSelectedField = (field, value) => {
    this.setState(prevState => ({
      selected: Object.assign({}, prevState.selected, { [field]: value }),
    }));
  };

  cancelEdit = () => {
    this.setState(prevState => ({
      selected: Object.assign({}, prevState.selectedOriginal),
      isEditing: false,
      saveMessage: '',
    }));
  };

  saveFulfilment = () => {
    axios.post(
      `${URL}/admin/bandcamp/fulfilments/update`,
      {
        fulfilmentOrder: this.state.selected,
      },
      { headers: authHeaders() },
    )
      .then((response) => {
        const { fulfilmentOrder } = response.data;
        this.setState(prevState => ({
          selected: Object.assign({}, fulfilmentOrder),
          selectedOriginal: Object.assign({}, fulfilmentOrder),
          isEditing: false,
          saveMessage: 'Fulfilment updated.',
          data: prevState.data.map(row => (row.id === fulfilmentOrder.id ? fulfilmentOrder : row)),
        }));
      })
      .catch(() => {
        this.setState({ saveMessage: 'There was a problem saving this fulfilment.' });
      });
  };

  deleteFulfilment = () => {
    if (!this.state.selected || !this.state.deleteEnabled) {
      return;
    }

    // eslint-disable-next-line no-alert
    const confirmed = window.confirm(`Delete fulfilment ${this.state.selected.id}? This cannot be undone.`);

    if (!confirmed) {
      return;
    }

    axios.post(
      `${URL}/admin/bandcamp/fulfilments/delete`,
      {
        id: this.state.selected.id,
      },
      { headers: authHeaders() },
    )
      .then(() => {
        this.setState({
          selected: null,
          selectedOriginal: null,
          deleteEnabled: false,
          deleteMessage: 'Fulfilment deleted.',
        }, this.refreshTable);
      })
      .catch(() => {
        this.setState({ deleteMessage: 'There was a problem deleting this fulfilment.' });
      });
  };

  exportCsv = () => {
    if (!this.state.tableState) {
      return;
    }

    this.setState({ exporting: true });

    axios.post(
      `${URL}/admin/bandcamp/fulfilments/list`,
      {
        page: 0,
        pageSize: this.state.count || 100000,
        sorted: this.state.tableState.sorted,
        filtered: this.state.tableFilters,
        clientId: this.state.clientId,
        shippedDateFrom: this.state.shippedDateFrom,
        shippedDateTo: this.state.shippedDateTo,
      },
      { headers: authHeaders() },
    )
      .then((response) => {
        const rows = response.data.items || [];
        const columns = [
          { label: 'MF ID', key: 'id' },
          { label: 'External Ref', key: 'external_order_payment_id' },
          { label: 'Customer Name', key: 'customer_name' },
          { label: 'Country', key: 'destination_country' },
          { label: 'Shipped Date', key: 'shipped_date', format: formatDate },
          { label: 'Carrier', key: 'shipping_carrier' },
          { label: 'Tracking Number', key: 'tracking_number' },
          { label: 'Weight', key: 'weight' },
          { label: 'Order Fee', key: 'order_fee' },
          { label: 'Packaging Fee', key: 'packaging_fee' },
          { label: 'Shipping Fee', key: 'client_shipping_price' },
        ];
        const csvRows = [
          columns.map(column => formatCsvValue(column.label)).join(','),
          ...rows.map(row => columns
            .map((column) => {
              const value = column.format ? column.format(row[column.key]) : row[column.key];
              return formatCsvValue(value);
            })
            .join(',')),
        ];
        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const date = new Date().toISOString().slice(0, 10);

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', `bandcamp-fulfilments-${date}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.setState({ exporting: false });
      })
      .catch(() => {
        this.setState({
          exporting: false,
          saveMessage: 'There was a problem exporting fulfilments.',
        });
      });
  };

  renderOrderItems = () => {
    if (!this.state.selected) {
      return null;
    }

    const orderItems = this.state.selected.order_items || [];

    return (
      <Card>
        <CardBody>
          <h4>Order Items</h4>
          {orderItems.length === 0 ? (
            <p>No order items found for this fulfilment.</p>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Item Name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {orderItems.map(item => (
                  <tr key={`${item.package_id || item.sku || item.item_name}-${item.quantity}-${item.price}`}>
                    <td>{item.sku || '-'}</td>
                    <td>{item.item_name || '-'}</td>
                    <td>{item.quantity || '-'}</td>
                    <td>
                      {item.price !== null && item.price !== undefined
                        ? currencyFormatGbp.format(item.price)
                        : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    );
  };

  renderSelectedDetails = () => {
    if (!this.state.selected) {
      return (
        <Card>
          <CardBody>
            <p>Select a fulfilment to view or edit it.</p>
          </CardBody>
        </Card>
      );
    }

    return (
      <Card>
        <CardBody>
          <Row>
            <Col md={3}>
              <p><strong>ID:</strong> {this.state.selected.id}</p>
            </Col>
            <Col md={3}>
              <p><strong>Order:</strong> {this.state.selected.external_order_payment_id || '-'}</p>
              <p><strong>Client:</strong> {this.state.selected.client_name || '-'}</p>
            </Col>
            <Col md={3}>
              <p><strong>Email:</strong> {this.state.selected.customer_email || '-'}</p>
              <p><strong>Phone:</strong> {this.state.selected.customer_phone || '-'}</p>
            </Col>
            <Col md={3}>
              <p><strong>Sales Channel:</strong> {this.state.selected.sales_channel || '-'}</p>
              <p><strong>Created:</strong> {formatDate(this.state.selected.created_date)}</p>
            </Col>
            <Col md={12}>
              <ButtonToolbar>
                {!this.state.isEditing ? (
                  <Button color="primary" onClick={() => this.setState({ isEditing: true })}>Edit</Button>
                ) : (
                  <React.Fragment>
                    <Button color="success" onClick={this.saveFulfilment}>Save Changes</Button>
                    <Button color="secondary" onClick={this.cancelEdit}>Cancel</Button>
                  </React.Fragment>
                )}
              </ButtonToolbar>
              {this.state.saveMessage ? <p>{this.state.saveMessage}</p> : null}
            </Col>
          </Row>

          <Row>
            {editableFields.map(field => (
              <Col md={3} key={field.key} style={{ marginBottom: 12 }}>
                <Label>{field.label}</Label>
                <Input
                  type={field.type}
                  step={field.step}
                  value={getFieldValue(this.state.selected, field)}
                  disabled={!this.state.isEditing}
                  onChange={event => this.updateSelectedField(field.key, event.target.value)}
                />
              </Col>
            ))}
          </Row>

          <hr />

          <Row>
            <Col md={8}>
              <Label check>
                <Input
                  type="checkbox"
                  checked={this.state.deleteEnabled}
                  onChange={event => this.setState({ deleteEnabled: event.target.checked })}
                />{' '}
                Enable delete for this fulfilment
              </Label>
              {this.state.deleteMessage ? <p>{this.state.deleteMessage}</p> : null}
            </Col>
            <Col md={4}>
              <Button
                color="danger"
                disabled={!this.state.deleteEnabled}
                onClick={this.deleteFulfilment}
              >
                Delete Fulfilment
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  };

  render() {
    const columns = [
      { Header: 'ID', accessor: 'id', width: 80 },
      { Header: 'Order Number', accessor: 'external_order_payment_id' },
      { Header: 'Client', accessor: 'client_name' },
      { Header: 'Status', accessor: 'status' },
      {
        Header: 'Shipped',
        accessor: 'shipped_date',
        Cell: row => formatDate(row.value),
      },
      { Header: 'Carrier', accessor: 'shipping_carrier' },
      { Header: 'Service', accessor: 'shipping_service' },
      { Header: 'Tracking', accessor: 'tracking_number' },
      {
        Header: 'Destination',
        accessor: 'destination_country',
        Filter: ({ filter, onChange }) => (
          <Input
            type="select"
            value={filter ? filter.value : ''}
            onChange={event => onChange(event.target.value)}
          >
            <option value="">All Countries</option>
            {countries.map(country => (
              <option key={country.value} value={country.label}>
                {country.label}
              </option>
            ))}
          </Input>
        ),
      },
    ];

    return (
      <Container className="dashboard">
        <Row>
          <Col md={12}>
            <h3 className="page-title">Bandcamp Fulfilments</h3>
          </Col>
        </Row>

        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <Label>Client</Label>
                <Input
                  type="select"
                  value={this.state.clientId}
                  onChange={event => this.updateFilter('clientId', event.target.value)}
                >
                  <option value="">All Clients</option>
                  {this.state.clients.map(client => (
                    <option key={client.id} value={client.id}>
                      {client.name}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Shipped From</Label>
                <Input
                  type="date"
                  value={this.state.shippedDateFrom}
                  onChange={event => this.updateFilter('shippedDateFrom', event.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Shipped To</Label>
                <Input
                  type="date"
                  value={this.state.shippedDateTo}
                  onChange={event => this.updateFilter('shippedDateTo', event.target.value)}
                />
              </Col>
            </Row>
            <ButtonToolbar style={{ marginTop: 12 }}>
              <Button color="primary" onClick={this.refreshTable}>Refresh</Button>
              <Button color="secondary" onClick={this.resetFilters}>Reset</Button>
              <Button color="success" disabled={this.state.exporting} onClick={this.exportCsv}>
                {this.state.exporting ? 'Exporting...' : 'Export CSV'}
              </Button>
            </ButtonToolbar>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <ReactTable
              manual
              filterable
              data={this.state.data}
              pages={this.state.pages}
              page={this.state.page}
              pageSize={this.state.pageSize}
              loading={this.state.loading}
              columns={columns}
              filtered={this.state.tableFilters}
              onFilteredChange={this.updateTableFilters}
              onPageChange={page => this.setState({ page })}
              onPageSizeChange={(pageSize, page) => this.setState({ pageSize, page })}
              onFetchData={this.fetchData}
              getTrProps={(state, rowInfo) => ({
                onClick: () => {
                  if (rowInfo && rowInfo.original) {
                    this.selectFulfilment(rowInfo.original);
                  }
                },
                style: {
                  cursor: 'pointer',
                  background: rowInfo && this.state.selected && rowInfo.original.id === this.state.selected.id
                    ? '#d7efff'
                    : '',
                },
              })}
            />
          </CardBody>
        </Card>

        {this.renderOrderItems()}

        {this.renderSelectedDetails()}
      </Container>
    );
  }
}

export default BandcampFulfilmentsTable;
